var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app","data-theme":_vm.theme}},[(_vm.layout && _vm.render && _vm.getLoginstatus == _vm.Enums.LoadingStatusType.Success)?_c('Layout'):_vm._e(),(!_vm.layout && _vm.render)?_c('router-view'):_vm._e(),(_vm.render)?_c('Noti'):_vm._e(),_c('portal-target',{attrs:{"name":"contextMenu"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }